import { PRODUCT_RAW_MATERIAL } from 'actionTypes';
import actionsFactory from 'utils/redux/baseEntitiesFactory/actions';
import reducerFactory from 'utils/redux/baseEntitiesFactory/reducer';
import sagasFactory from 'utils/redux/baseEntitiesFactory/sagas';
import thunkFactory from 'utils/redux/baseEntitiesFactory/thunk';

// ACTIONS
const rawActions = actionsFactory(PRODUCT_RAW_MATERIAL);
const actions = {
  ...rawActions,
  ...thunkFactory(PRODUCT_RAW_MATERIAL, '/product_raw_materials/'),
};
export { actions };

// REDUCER
const initialState = {
  ids: [],
  models: {},
  loaded: false,
  loading: false,
  errorMessage: '',
  submitting: false
};

export default reducerFactory(PRODUCT_RAW_MATERIAL, initialState);

// SAGAS
const sagas = sagasFactory(PRODUCT_RAW_MATERIAL, '/product_raw_materials/', { scopedByAccount: true });
export { sagas };
